import { useTenantSwitch } from '@kp/react-sdk';

import { useQuery } from '@tanstack/react-query';

import { getUserTenants } from '@/api/user';

/**
 * Name of the current tenant. Shares the `TenantSwitch` query cache; a failed
 * request only leaves the name undefined (the header omits the segment).
 */
export const useTenantName = () => {
  const { currentTenantId } = useTenantSwitch();
  const { data, isLoading } = useQuery({
    queryKey: ['getUserTenants'],
    queryFn: () => getUserTenants(0, 100),
  });

  return {
    name: data?.data?.find((tenant) => tenant.id === currentTenantId)?.name,
    isLoading,
  };
};
